module.exports = __webpack_public_path__ + "assets/img/HR-Connect-Website-w960.c1451671.jpg";